import * as React from 'react';

import TypedTransComponent from 'shared/components/TypedTransComponent';
import ExternalLink from 'shared/newComponents/ExternalLink';
import Typography from 'shared/newComponents/Typography';
import {
  TypographyColor,
  TypographySize,
  TypographyType
} from 'shared/newEntities/components/Typography';

import { InstructionSlotProps } from '../FormWithToken';

const DefaultInstructionSlot: React.FC<InstructionSlotProps> = ({
  url,
  creatingBotName,
  command,
  onCopyCommand
}) => {
  return (
    <Typography fontType={TypographyType.text} fontSize={TypographySize.m}>
      <TypedTransComponent
        ns="newContainers"
        i18nKey="ChannelsModal.ChannelForm.FormWithToken.instruction"
      >
        Перейдите в{'&nbsp;'}
        <ExternalLink
          fontType={TypographyType.text}
          fontSize={TypographySize.m}
          fontColor={TypographyColor.link}
          underline
          href={url}
        >
          {{ creatingBotName }}
        </ExternalLink>
        , введите команду{'&nbsp;'}
        <Typography
          Element="span"
          fontType={TypographyType.text}
          fontSize={TypographySize.m}
          fontColor={TypographyColor.link}
          onClick={onCopyCommand}
        >
          {{ command }}
        </Typography>
        , создайте бота и вставьте полученный токен ниже.
      </TypedTransComponent>
    </Typography>
  );
};

export default React.memo(DefaultInstructionSlot);
